import { render, staticRenderFns } from "./InvitationConfiguration.vue?vue&type=template&id=54777df8"
import script from "./InvitationConfiguration.vue?vue&type=script&lang=js"
export * from "./InvitationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./InvitationConfiguration.vue?vue&type=style&index=0&id=54777df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports